import { useQuery } from '@tanstack/react-query'
import { fetchPhrases } from './api'
import type { Phrase } from './types'

/**
 * Словарь фраз — один запрос на всё приложение.
 *
 * Он не меняется, пока не обновится сервер, поэтому запрос вечно свежий: как
 * и геометрия доски, это описание, а не состояние.
 *
 * Выключатель обязателен, а не «на всякий случай»: партия за одним
 * устройством обязана открываться БЕЗ ЕДИНОГО запроса — она и считается на
 * этом же устройстве, и чата у неё нет вовсе (закреплено тестом в
 * App.test.tsx). Без него словарь уезжал за сеть даже там.
 */
export function usePhrases(enabled = true) {
  return useQuery({
    queryKey: ['chat', 'phrases'],
    queryFn: fetchPhrases,
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  })
}

/**
 * Как выглядит реплика.
 *
 * Готовая фраза — текстом из словаря, свободный текст — собой. Незнакомый
 * код показывается как есть: это значит, что клиент старее сервера, и
 * прятать такую реплику хуже, чем показать её кодом, — иначе разговор
 * молча теряет строки.
 */
export function say(phrases: Phrase[] | undefined, kind: string, body: string): string {
  if (kind !== 'phrase') return body

  return phrases?.find((phrase) => phrase.code === body)?.text ?? body
}
